import React, { useEffect, useState, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import axiosInstance from "../../axiosConfig";
import './ClubDashboard.css';

// Icons as simple SVG components
const Icons = {
  Users: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  ),
  Clock: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
  ),
  Check: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  ),
  Message: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
    </svg>
  ),
  TrendingUp: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
      <polyline points="17 6 23 6 23 12"></polyline>
    </svg>
  ),
  MapPin: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
      <circle cx="12" cy="10" r="3"></circle>
    </svg>
  ),
  Send: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="22" y1="2" x2="11" y2="13"></line>
      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
    </svg>
  ),
  X: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  ),
  ChevronRight: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6"></polyline>
    </svg>
  ),
  Search: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  ),
  Home: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
      <polyline points="9 22 9 12 15 12 15 22"></polyline>
    </svg>
  ),
  Feed: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="17" y1="10" x2="3" y2="10"></line>
      <line x1="21" y1="6" x2="3" y2="6"></line>
      <line x1="21" y1="14" x2="3" y2="14"></line>
      <line x1="17" y1="18" x2="3" y2="18"></line>
    </svg>
  ),
  Map: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon>
      <line x1="8" y1="2" x2="8" y2="18"></line>
      <line x1="16" y1="6" x2="16" y2="22"></line>
    </svg>
  ),
  Forum: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
    </svg>
  ),
  ExternalLink: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
      <polyline points="15 3 21 3 21 9"></polyline>
      <line x1="10" y1="14" x2="21" y2="3"></line>
    </svg>
  ),
};

// Stat Card Component
function StatCard({ icon, label, value, subValue, trend, color = "primary" }) {
  const colorClasses = {
    primary: "stat-card-primary",
    success: "stat-card-success",
    warning: "stat-card-warning",
    info: "stat-card-info",
  };

  return (
    <div className={`stat-card ${colorClasses[color]}`}>
      <div className="stat-card-icon">{icon}</div>
      <div className="stat-card-content">
        <span className="stat-card-label">{label}</span>
        <span className="stat-card-value">{value}</span>
        {subValue && <span className="stat-card-subvalue">{subValue}</span>}
        {trend && (
          <span className={`stat-card-trend ${trend > 0 ? 'positive' : 'negative'}`}>
            {trend > 0 ? '↑' : '↓'} {Math.abs(trend)}%
          </span>
        )}
      </div>
    </div>
  );
}

// Sidebar Navigation Component
function Sidebar({ activeSection, setActiveSection, clubData, stats }) {
  const navItems = [
    { id: "overview", label: "Overview", icon: <Icons.TrendingUp /> },
    { id: "nearby", label: "Discover Users", icon: <Icons.MapPin /> },
    { id: "pending", label: "Pending", icon: <Icons.Clock />, badge: stats?.pending || 0 },
    { id: "approved", label: "Approved", icon: <Icons.Check />, badge: stats?.approved || 0 },
    { id: "conversations", label: "Conversations", icon: <Icons.Message />, badge: stats?.unreadMessages || 0 },
  ];

  const exploreLinks = [
    { to: "/feestable", label: "Home", icon: <Icons.Home /> },
    { to: "/feed", label: "Feed", icon: <Icons.Feed /> },
    { to: "/courses", label: "Map", icon: <Icons.Map /> },
    { to: "/forums", label: "Forums", icon: <Icons.Forum /> },
  ];

  return (
    <aside className="dashboard-sidebar">

      <div className="sidebar-club-info">
        <h3>{clubData?.name || "Loading..."}</h3>
        <p>{clubData?.city}, {clubData?.state}</p>
      </div>

      <nav className="sidebar-nav">
        <div className="sidebar-nav-section">
          <span className="sidebar-nav-label">Dashboard</span>
          {navItems.map((item) => (
            <button
              key={item.id}
              className={`sidebar-nav-item ${activeSection === item.id ? "active" : ""}`}
              onClick={() => setActiveSection(item.id)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
              {item.badge > 0 && <span className="nav-badge">{item.badge}</span>}
            </button>
          ))}
        </div>

        <div className="sidebar-nav-section">
          <span className="sidebar-nav-label">Explore PrivateIQ</span>
          {exploreLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="sidebar-nav-item explore-link"
            >
              <span className="nav-icon">{link.icon}</span>
              <span className="nav-label">{link.label}</span>
              <span className="external-icon"><Icons.ExternalLink /></span>
            </Link>
          ))}
        </div>
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-contact">
          <p><strong>Need help?</strong></p>
          <p>support@privateiq.com</p>
        </div>
      </div>
    </aside>
  );
}

// Overview Section Component
function OverviewSection({ stats, recentActivity, clubData }) {
  return (
    <div className="overview-section">
      <div className="section-header">
        <h1>Dashboard Overview</h1>
        <p className="section-subtitle">Welcome back! Here's what's happening with your member outreach.</p>
      </div>

      <div className="stats-grid">
        <StatCard
          icon={<Icons.Users />}
          label="Total Requests Sent"
          value={stats?.total_requests_sent || 0}
          color="primary"
        />
        <StatCard
          icon={<Icons.Clock />}
          label="Pending Approval"
          value={stats?.pending || 0}
          color="warning"
        />
        <StatCard
          icon={<Icons.Check />}
          label="Approved Connections"
          value={stats?.approved || 0}
          color="success"
        />
        <StatCard
          icon={<Icons.Message />}
          label="Active Conversations"
          value={stats?.active_conversations || 0}
          color="info"
        />
      </div>

      <div className="overview-grid">
        <div className="overview-card conversion-funnel">
          <h3>Conversion Funnel</h3>
          <div className="funnel-chart">
            <div className="funnel-item">
              <div className="funnel-bar" style={{ width: '100%' }}>
                <span className="funnel-label">Requests Sent</span>
                <span className="funnel-value">{stats?.total_requests_sent || 0}</span>
              </div>
            </div>
            <div className="funnel-item">
              <div
                className="funnel-bar approved"
                style={{
                  width: stats?.total_requests_sent
                    ? `${((stats?.approved || 0) / stats?.total_requests_sent * 100)}%`
                    : '0%'
                }}
              >
                <span className="funnel-label">Approved</span>
                <span className="funnel-value">{stats?.approved || 0}</span>
              </div>
            </div>
            <div className="funnel-item">
              <div
                className="funnel-bar active"
                style={{
                  width: stats?.total_requests_sent
                    ? `${((stats?.active_conversations || 0) / stats?.total_requests_sent * 100)}%`
                    : '0%'
                }}
              >
                <span className="funnel-label">In Conversation</span>
                <span className="funnel-value">{stats?.active_conversations || 0}</span>
              </div>
            </div>
          </div>
          {stats?.total_requests_sent > 0 && (
            <div className="funnel-stats">
              <div className="funnel-stat">
                <span className="stat-value">
                  {((stats?.approved || 0) / stats?.total_requests_sent * 100).toFixed(1)}%
                </span>
                <span className="stat-label">Approval Rate</span>
              </div>
              <div className="funnel-stat">
                <span className="stat-value">
                  {stats?.approved > 0
                    ? ((stats?.active_conversations || 0) / stats?.approved * 100).toFixed(1)
                    : 0}%
                </span>
                <span className="stat-label">Engagement Rate</span>
              </div>
            </div>
          )}
        </div>

        <div className="overview-card quick-actions">
          <h3>Quick Actions</h3>
          <div className="action-buttons">
            <button className="action-btn primary" onClick={() => {}}>
              <Icons.MapPin />
              <span>Find New Prospects</span>
            </button>
            <button className="action-btn secondary" onClick={() => {}}>
              <Icons.Message />
              <span>View Messages</span>
            </button>
          </div>
          <div className="tips-section">
            <h4>💡 Tips for Success</h4>
            <ul>
              <li>Respond to approvals within 24 hours for best engagement</li>
              <li>Personalize your outreach based on member demographics</li>
              <li>Use the distance filter to target nearby prospects first</li>
            </ul>
          </div>
        </div>
      </div>

      {recentActivity && recentActivity.length > 0 && (
        <div className="recent-activity-card">
          <h3>Recent Activity</h3>
          <div className="activity-list">
            {recentActivity.slice(0, 5).map((activity, index) => (
              <div key={index} className="activity-item">
                <div className="activity-icon">
                  {activity.type === 'approved' ? <Icons.Check /> : <Icons.Clock />}
                </div>
                <div className="activity-content">
                  <p className="activity-text">{activity.message}</p>
                  <span className="activity-time">{activity.time}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// User Table Component
function UserTable({ users, type, onAction, actionLabel, actionIcon }) {
  const formatIncomeRange = (range) => {
    if (!range) return "N/A";
    if (range === "1000000+") return "$1M+";
    const [low, high] = range.split("-");
    const formattedHigh = high === "1000000" ? "$1M" : `$${(high / 1000).toFixed()}K`;
    return `$${(low / 1000).toFixed()}K - ${formattedHigh}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const options = { month: 'short', day: 'numeric', year: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  if (!users || users.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-icon">
          <Icons.Users />
        </div>
        <h3>No {type} found</h3>
        <p>
          {type === "nearby users"
            ? "Try expanding your search radius to find more prospects."
            : `You don't have any ${type} yet.`}
        </p>
      </div>
    );
  }

  return (
    <div className="modern-table-container">
      <table className="modern-table">
        <thead>
          <tr>
            {type === "approved" && <th>Name</th>}
            {type === "approved" && <th>Contact</th>}
            <th>Age</th>
            <th>Income</th>
            <th>Status</th>
            {type !== "approved" && <th>Distance</th>}
            {type === "pending" && <th>Requested</th>}
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={user.id || index}>
              {type === "approved" && (
                <td>
                  <div className="user-name-cell">
                    <div className="user-avatar">
                      {(user.full_name || "U").charAt(0).toUpperCase()}
                    </div>
                    <span>{user.full_name || "Unknown"}</span>
                  </div>
                </td>
              )}
              {type === "approved" && (
                <td>
                  <div className="contact-cell">
                    <a href={`mailto:${user.email}`}>{user.email}</a>
                    {user.phone_number && <span>{user.phone_number}</span>}
                  </div>
                </td>
              )}
              <td>
                <span className="badge badge-neutral">{user.age || "N/A"}</span>
              </td>
              <td>{formatIncomeRange(user.household_income)}</td>
              <td>
                <span className={`badge ${user.current_club_member === "yes" ? "badge-success" : "badge-neutral"}`}>
                  {user.current_club_member === "yes" ? "Member" : "Non-member"}
                </span>
              </td>
              {type !== "approved" && (
                <td>{user.distance ? `${user.distance.toFixed(1)} mi` : "N/A"}</td>
              )}
              {type === "pending" && (
                <td>{formatDate(user.created_at)}</td>
              )}
              <td>
                {onAction && (
                  <button
                    className="table-action-btn"
                    onClick={() => onAction(user.id || user.interaction_request_id)}
                  >
                    {actionIcon}
                    <span>{actionLabel}</span>
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// Nearby Users Section
function NearbyUsersSection({ users, radius, setRadius, onRequestInfo, loading }) {
  return (
    <div className="content-section">
      <div className="section-header">
        <div>
          <h1>Discover Prospects</h1>
          <p className="section-subtitle">Find potential members near your club</p>
        </div>
      </div>

      <div className="filter-card">
        <div className="filter-row">
          <div className="filter-item radius-filter">
            <label>Search Radius: <strong>{radius} miles</strong></label>
            <Slider
              min={1}
              max={100}
              value={radius}
              onChange={setRadius}
              step={1}
            />
          </div>
          <div className="filter-results">
            <span className="result-count">{users?.length || 0}</span>
            <span className="result-label">prospects found</span>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Finding nearby prospects...</p>
        </div>
      ) : (
        <UserTable
          users={users}
          type="nearby users"
          onAction={onRequestInfo}
          actionLabel="Request Info"
          actionIcon={<Icons.Send />}
        />
      )}
    </div>
  );
}

// Pending Requests Section
function PendingRequestsSection({ requests, loading }) {
  return (
    <div className="content-section">
      <div className="section-header">
        <div>
          <h1>Pending Requests</h1>
          <p className="section-subtitle">Awaiting member approval</p>
        </div>
        <div className="section-stats">
          <span className="stat-badge warning">{requests?.length || 0} pending</span>
        </div>
      </div>

      {loading ? (
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Loading pending requests...</p>
        </div>
      ) : (
        <UserTable
          users={requests}
          type="pending"
        />
      )}
    </div>
  );
}

// Approved Requests Section
function ApprovedRequestsSection({ requests, onStartConversation, loading }) {
  return (
    <div className="content-section">
      <div className="section-header">
        <div>
          <h1>Approved Connections</h1>
          <p className="section-subtitle">Members who want to connect with you</p>
        </div>
        <div className="section-stats">
          <span className="stat-badge success">{requests?.length || 0} approved</span>
        </div>
      </div>

      {loading ? (
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Loading approved requests...</p>
        </div>
      ) : (
        <UserTable
          users={requests}
          type="approved"
          onAction={onStartConversation}
          actionLabel="Message"
          actionIcon={<Icons.Message />}
        />
      )}
    </div>
  );
}

// Conversations Section
function ConversationsSection({ conversations, onSelectConversation, selectedConversation, loading }) {
  const [messageInput, setMessageInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [messagesLoading, setMessagesLoading] = useState(false);

  useEffect(() => {
    if (selectedConversation) {
      loadMessages(selectedConversation.interaction_request_id);
    }
  }, [selectedConversation]);

  const loadMessages = async (requestId) => {
    setMessagesLoading(true);
    try {
      const response = await axiosInstance.get(`club-interface/conversations/${requestId}/messages/`);
      setMessages(response.data.messages || []);
    } catch (error) {
      console.error("Failed to load messages:", error);
    }
    setMessagesLoading(false);
  };

  const sendMessage = async () => {
    if (!messageInput.trim() || !selectedConversation) return;

    try {
      await axiosInstance.post(
        `club-interface/conversations/${selectedConversation.interaction_request_id}/send/`,
        { content: messageInput }
      );
      setMessageInput("");
      loadMessages(selectedConversation.interaction_request_id);
    } catch (error) {
      console.error("Failed to send message:", error);
    }
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="content-section conversations-section">
      <div className="section-header">
        <div>
          <h1>Conversations</h1>
          <p className="section-subtitle">Message your approved connections</p>
        </div>
      </div>

      <div className="conversations-container">
        {/* Conversation List */}
        <div className="conversation-list">
          {loading ? (
            <div className="loading-state">
              <div className="loading-spinner"></div>
            </div>
          ) : conversations && conversations.length > 0 ? (
            conversations
              .filter(c => c.status === 'approved')
              .map((conv) => (
                <div
                  key={conv.interaction_request_id}
                  className={`conversation-item ${selectedConversation?.interaction_request_id === conv.interaction_request_id ? 'active' : ''}`}
                  onClick={() => onSelectConversation(conv)}
                >
                  <div className="conversation-avatar">
                    {(conv.user?.full_name || "U").charAt(0).toUpperCase()}
                  </div>
                  <div className="conversation-info">
                    <h4>{conv.user?.full_name || "Unknown User"}</h4>
                    <p className="last-message">
                      {conv.latest_message?.content?.substring(0, 40) || "No messages yet"}
                      {conv.latest_message?.content?.length > 40 ? "..." : ""}
                    </p>
                  </div>
                  {conv.unread_count > 0 && (
                    <span className="unread-badge">{conv.unread_count}</span>
                  )}
                </div>
              ))
          ) : (
            <div className="empty-conversations">
              <Icons.Message />
              <p>No conversations yet</p>
              <span>Approved connections will appear here</span>
            </div>
          )}
        </div>

        {/* Chat Window */}
        <div className="chat-window">
          {selectedConversation ? (
            <>
              <div className="chat-header">
                <div className="chat-user-info">
                  <div className="chat-avatar">
                    {(selectedConversation.user?.full_name || "U").charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <h4>{selectedConversation.user?.full_name || "Unknown User"}</h4>
                    <span className="user-details">
                      {selectedConversation.user?.demographics?.age && `${selectedConversation.user.demographics.age} years old`}
                      {selectedConversation.user?.demographics?.current_club_member === "yes" && " • Club Member"}
                    </span>
                  </div>
                </div>
              </div>

              <div className="chat-messages">
                {messagesLoading ? (
                  <div className="loading-state">
                    <div className="loading-spinner"></div>
                  </div>
                ) : messages.length > 0 ? (
                  messages.map((msg, index) => (
                    <div
                      key={msg.id || index}
                      className={`message ${msg.is_sent_by_club ? 'sent' : 'received'}`}
                    >
                      <div className="message-content">{msg.content}</div>
                      <span className="message-time">{formatTime(msg.timestamp)}</span>
                    </div>
                  ))
                ) : (
                  <div className="no-messages">
                    <p>No messages yet. Start the conversation!</p>
                  </div>
                )}
              </div>

              <div className="chat-input-container">
                <input
                  type="text"
                  placeholder="Type a message..."
                  value={messageInput}
                  onChange={(e) => setMessageInput(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
                />
                <button onClick={sendMessage} disabled={!messageInput.trim()}>
                  <Icons.Send />
                </button>
              </div>
            </>
          ) : (
            <div className="no-conversation-selected">
              <Icons.Message />
              <h3>Select a conversation</h3>
              <p>Choose a connection from the list to start messaging</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// Main Dashboard Component
function ClubDashboard() {
  const { clubId } = useParams();
  const [activeSection, setActiveSection] = useState("overview");
  const [clubData, setClubData] = useState(null);
  const [nearbyUsers, setNearbyUsers] = useState([]);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [approvedRequests, setApprovedRequests] = useState([]);
  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [stats, setStats] = useState({});
  const [error, setError] = useState("");
  const [radius, setRadius] = useState(20);
  const [loading, setLoading] = useState({
    nearby: false,
    pending: false,
    approved: false,
    conversations: false,
  });

  // Fetch club data
  useEffect(() => {
    const fetchClubData = async () => {
      try {
        const response = await axiosInstance.get(`myclub/dashboard/`, {
          params: { club_id: clubId },
        });
        setClubData(response.data);
      } catch (error) {
        setError("Failed to fetch club data. Please try again.");
      }
    };
    fetchClubData();
  }, [clubId]);

  // Fetch conversations and stats for overview
  useEffect(() => {
    const fetchConversationsAndStats = async () => {
      try {
        const response = await axiosInstance.get('club-interface/conversations/');
        setConversations(response.data.conversations || []);
        setStats(response.data.stats || {});
      } catch (error) {
        console.error("Failed to fetch conversations:", error);
      }
    };
    fetchConversationsAndStats();
  }, []);

  // Fetch data based on active section
  useEffect(() => {
    const fetchData = async () => {
      if (activeSection === "nearby") {
        setLoading(prev => ({ ...prev, nearby: true }));
        try {
          const response = await axiosInstance.get('myclub/nearby-users/', {
            params: { radius },
          });
          setNearbyUsers(response.data.nearby_users || []);
        } catch (error) {
          console.error("Failed to fetch nearby users:", error);
        }
        setLoading(prev => ({ ...prev, nearby: false }));
      } else if (activeSection === "pending") {
        setLoading(prev => ({ ...prev, pending: true }));
        try {
          const response = await axiosInstance.get('myclub/requests/pending/');
          setPendingRequests(response.data.requests || []);
        } catch (error) {
          console.error("Failed to fetch pending requests:", error);
        }
        setLoading(prev => ({ ...prev, pending: false }));
      } else if (activeSection === "approved") {
        setLoading(prev => ({ ...prev, approved: true }));
        try {
          const response = await axiosInstance.get('myclub/requests/approved/');
          setApprovedRequests(response.data.requests || []);
        } catch (error) {
          console.error("Failed to fetch approved requests:", error);
        }
        setLoading(prev => ({ ...prev, approved: false }));
      } else if (activeSection === "conversations") {
        setLoading(prev => ({ ...prev, conversations: true }));
        try {
          const response = await axiosInstance.get('club-interface/conversations/');
          setConversations(response.data.conversations || []);
        } catch (error) {
          console.error("Failed to fetch conversations:", error);
        }
        setLoading(prev => ({ ...prev, conversations: false }));
      }
    };
    fetchData();
  }, [activeSection, radius]);

  const handleRequestInfo = async (userId) => {
    try {
      const response = await axiosInstance.post('myclub/interactions/create', {
        user_id: userId,
      });
      // Remove user from nearby list after request
      setNearbyUsers(prev => prev.filter(u => u.id !== userId));
      // Show success message (you could use a toast library here)
      alert(response.data.message || "Request sent successfully!");
    } catch (error) {
      alert("Failed to send interaction request. Please try again.");
    }
  };

  const handleStartConversation = (requestId) => {
    const conv = conversations.find(c => c.interaction_request_id === requestId);
    if (conv) {
      setSelectedConversation(conv);
      setActiveSection("conversations");
    }
  };

  if (error) {
    return (
      <div className="dashboard-error">
        <Icons.X />
        <h2>Error</h2>
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>Retry</button>
      </div>
    );
  }

  return (
    <div className="club-dashboard">
      <Sidebar
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        clubData={clubData}
        stats={stats}
      />

      <main className="dashboard-main">
        {activeSection === "overview" && (
          <OverviewSection stats={stats} clubData={clubData} />
        )}
        {activeSection === "nearby" && (
          <NearbyUsersSection
            users={nearbyUsers}
            radius={radius}
            setRadius={setRadius}
            onRequestInfo={handleRequestInfo}
            loading={loading.nearby}
          />
        )}
        {activeSection === "pending" && (
          <PendingRequestsSection
            requests={pendingRequests}
            loading={loading.pending}
          />
        )}
        {activeSection === "approved" && (
          <ApprovedRequestsSection
            requests={approvedRequests}
            onStartConversation={handleStartConversation}
            loading={loading.approved}
          />
        )}
        {activeSection === "conversations" && (
          <ConversationsSection
            conversations={conversations}
            onSelectConversation={setSelectedConversation}
            selectedConversation={selectedConversation}
            loading={loading.conversations}
          />
        )}
      </main>
    </div>
  );
}

export default ClubDashboard;